import DataFilterEnumCheckBoxHandler from "./enumCheckBox/DataFilterEnumCheckBoxHandler";
import DataFilterTextBoxHandler from "./textBox/DataFilterTextBoxHandler";
import DataFilterSelectInputBoxCurrencyHandler from "./selecBoxCurrency/DataFilterSelectInputBoxCurrencyHandler";
import DataFilterRangeBoxCurrencyHandler from "./rangeBoxCurrency/DataFilterRangeBoxCurrencyHandler";
import DataFilterDateRangeBoxHandler from "./dateRangeBox/DataFilterDateRangeBoxHandler";
import DataFilterCheckBoxHandler from "./checkBox/DataFilterCheckBoxHandler";
import DataFilterRangeBoxHandler from "./rangeBox/DataFilterRangeBoxHandler";
import DataFilterEnumRadioBoxHandler from "./enumRadioBox/DataFilterEnumRadioBoxHandler";
import DataFilterSelectInputBoxHandler from "./selectBox/DataFilterSelectInputBoxHandler";
import DataFilterRadioInputBoxHandler from "./radioBox/DataFilterRadioInputBoxHandler";
import DataFilterEnumSelectInputBoxHandler from "./enumSelectBox/DataFilterEnumSelectInputBoxHandler";


const TextBox = () => new DataFilterTextBoxHandler();

const CheckBox = () => new DataFilterCheckBoxHandler();

const EnumCheckBox = () => new DataFilterEnumCheckBoxHandler();

const RangeBox = () => new DataFilterRangeBoxHandler();

const RangeBoxCurrency = () => new DataFilterRangeBoxCurrencyHandler();

const DateRangeBox = () => new DataFilterDateRangeBoxHandler();

const EnumRadioBox = () => new DataFilterEnumRadioBoxHandler();

const SelectInputBox = () => new DataFilterSelectInputBoxHandler();

const EnumSelectInputBox = () => new DataFilterEnumSelectInputBoxHandler();

const SelectInputBoxCurrency = () => new DataFilterSelectInputBoxCurrencyHandler();

const RadioInputBox = () => new DataFilterRadioInputBoxHandler();

export const DataFilterHandlersMapper: any = {
    TextBox,
    CheckBox,
    EnumCheckBox,
    RangeBox,
    RangeBoxCurrency,
    DateRangeBox,
    EnumRadioBox,
    SelectInputBox,
    EnumSelectInputBox,
    SelectInputBoxCurrency,
    RadioInputBox
}